/* Like Kids — localizador de lojas (porte vanilla do StoreLocator + MapView).
   Leaflet (vendorizado) + lista filtrável + seleção sincronizada lista↔mapa.
   Dados das lojas vêm de <script type="application/json" data-lk-lojas>.

   Dois modos de busca:
   - TEXTO: casa por nome/cidade/UF (substring), como antes.
   - PROXIMIDADE: quando a busca é um CEP de 8 dígitos, o CEP é convertido em
     coordenada e TODAS as lojas são ordenadas por distância — sem filtrar.
     Antes o CEP era tratado como texto, então só achava a loja cujo CEP fosse
     literalmente igual ao digitado. */
(function () {
  var GEO_ENDPOINT = "https://brasilapi.com.br/api/cep/v2/";
  var VIACEP_ENDPOINT = "https://viacep.com.br/ws/";
  var DEBOUNCE_MS = 350;

  function esc(s) {
    var d = document.createElement("div");
    d.textContent = s == null ? "" : String(s);
    return d.innerHTML;
  }

  function markerIcon(selected) {
    var svg = selected
      ? '<svg xmlns="http://www.w3.org/2000/svg" width="32" height="42" viewBox="0 0 28 36"><path d="M14 0C6.268 0 0 6.268 0 14c0 9.333 14 22 14 22S28 23.333 28 14C28 6.268 21.732 0 14 0z" fill="#5b2b90"/><circle cx="14" cy="14" r="6" fill="#ffdf20"/></svg>'
      : '<svg xmlns="http://www.w3.org/2000/svg" width="28" height="36" viewBox="0 0 28 36"><path d="M14 0C6.268 0 0 6.268 0 14c0 9.333 14 22 14 22S28 23.333 28 14C28 6.268 21.732 0 14 0z" fill="#ee6c97"/><circle cx="14" cy="14" r="6" fill="white"/></svg>';
    return L.divIcon({
      html: svg,
      iconSize: selected ? [32, 42] : [28, 36],
      iconAnchor: selected ? [16, 42] : [14, 36],
      popupAnchor: [0, selected ? -42 : -36],
      className: "",
    });
  }

  /* Marcador do CEP buscado — visualmente distinto das lojas (é o "você está aqui"). */
  function originIcon() {
    return L.divIcon({
      html:
        '<svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26">' +
        '<circle cx="13" cy="13" r="11" fill="#1a6fc4" fill-opacity="0.25"/>' +
        '<circle cx="13" cy="13" r="6" fill="#1a6fc4" stroke="white" stroke-width="2.5"/></svg>',
      iconSize: [26, 26],
      iconAnchor: [13, 13],
      className: "",
    });
  }

  /* ---------- geografia ---------- */

  function onlyDigits(s) {
    return (s || "").replace(/\D/g, "");
  }

  /* Só tratamos como CEP quando o usuário digitou apenas números/hífen/espaço.
     "Rua 15 de Novembro 1100" não deve virar consulta de CEP. */
  function asCep(query) {
    if (!/^[\d\s.-]+$/.test(query || "")) return null;
    var d = onlyDigits(query);
    return d.length === 8 ? d : null;
  }

  function haversineKm(a, b) {
    var R = 6371;
    var dLat = ((b.lat - a.lat) * Math.PI) / 180;
    var dLng = ((b.lng - a.lng) * Math.PI) / 180;
    var la1 = (a.lat * Math.PI) / 180;
    var la2 = (b.lat * Math.PI) / 180;
    var h =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.sin(dLng / 2) * Math.sin(dLng / 2) * Math.cos(la1) * Math.cos(la2);
    return 2 * R * Math.asin(Math.sqrt(h));
  }

  function formatKm(km) {
    if (km < 1) return Math.round(km * 1000) + " m";
    if (km < 10) return km.toFixed(1).replace(".", ",") + " km";
    return Math.round(km) + " km";
  }

  /* CEP → coordenada. BrasilAPI v2 devolve location.coordinates quando conhece o
     ponto; quando não devolve, caímos no ViaCEP só para saber cidade/UF e ao menos
     ordenar pela cidade certa. Ambos são públicos e sem chave. */
  var cepCache = {};

  function geocodeCep(cep) {
    if (cepCache[cep]) return Promise.resolve(cepCache[cep]);

    return fetch(GEO_ENDPOINT + cep)
      .then(function (r) {
        if (r.status === 404) return { status: "notfound" };
        if (!r.ok) throw new Error("HTTP " + r.status);
        return r.json().then(function (data) {
          var c = data && data.location && data.location.coordinates;
          var lat = c && parseFloat(c.latitude);
          var lng = c && parseFloat(c.longitude);
          if (isFinite(lat) && isFinite(lng)) {
            return { status: "ok", lat: lat, lng: lng, cidade: data.city, uf: data.state };
          }
          // Sem coordenada: guardamos cidade/UF para o fallback por cidade.
          return { status: "nocoords", cidade: data.city, uf: data.state };
        });
      })
      .catch(function () {
        // BrasilAPI fora do ar: tenta o ViaCEP só para cidade/UF.
        return fetch(VIACEP_ENDPOINT + cep + "/json/")
          .then(function (r) { return r.json(); })
          .then(function (d) {
            if (!d || d.erro) return { status: "notfound" };
            return { status: "nocoords", cidade: d.localidade, uf: d.uf };
          })
          .catch(function () { return { status: "error" }; });
      })
      .then(function (result) {
        if (result.status !== "error") cepCache[cep] = result;
        return result;
      });
  }

  /* ---------- init ---------- */

  function init() {
    var root = document.querySelector("[data-lk-store-locator]");
    if (!root || typeof L === "undefined") return;

    var dataEl = document.querySelector("[data-lk-lojas]");
    var lojas = [];
    try {
      lojas = (JSON.parse(dataEl.textContent) || {}).lojas || [];
    } catch (e) {
      return;
    }

    var listEl = root.querySelector("[data-lk-list]");
    var searchEl = root.querySelector("[data-lk-search]");
    var countEl = root.querySelector("[data-lk-count]");
    var mapEl = root.querySelector("[data-lk-map]");
    var iconUrl = root.getAttribute("data-lk-icon") || "";

    var selectedId = null;
    var markers = {};
    var originMarker = null;

    /* O que a lista mostra agora. Fica em estado próprio porque o modo
       proximidade resolve de forma assíncrona e o select() re-renderiza. */
    var view = { mode: "text", items: lojas, origin: null, note: "", empty: "Nenhuma loja encontrada." };

    var map = L.map(mapEl, { scrollWheelZoom: false }).setView([-15.77972, -47.92972], 4);
    // OpenStreetMap — sem API key
    L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
      maxZoom: 19,
      attribution:
        '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>',
    }).addTo(map);

    lojas.forEach(function (loja) {
      var m = L.marker([loja.lat, loja.lng], { icon: markerIcon(false) }).bindPopup(
        '<strong style="display:block;font-size:13px">' + esc(loja.nome) + "</strong>" +
          '<span style="font-size:12px;color:#52525b">' + esc(loja.endereco) + "</span><br>" +
          '<span style="font-size:12px;color:#71717a">' + esc(loja.cidade) + " / " + esc(loja.uf) + "</span>"
      );
      m.on("click", function () { select(loja.id); });
      m.addTo(map);
      markers[loja.id] = m;
    });

    function textMatch(q) {
      return lojas.filter(function (l) {
        return (
          l.nome.toLowerCase().indexOf(q) > -1 ||
          l.cidade.toLowerCase().indexOf(q) > -1 ||
          l.uf.toLowerCase().indexOf(q) > -1 ||
          String(l.cep).indexOf(q) > -1
        );
      });
    }

    function setOriginMarker(origin) {
      if (originMarker) { map.removeLayer(originMarker); originMarker = null; }
      if (!origin) return;
      originMarker = L.marker([origin.lat, origin.lng], { icon: originIcon(), zIndexOffset: 1000 })
        .bindPopup('<span style="font-size:12px">CEP ' + esc(origin.label) + "</span>")
        .addTo(map);
    }

    /* Enquadra o CEP + as lojas mais próximas, para o usuário ver a relação. */
    function fitToNearest(origin, items, howMany) {
      var pts = [[origin.lat, origin.lng]];
      items.slice(0, howMany).forEach(function (l) { pts.push([l.lat, l.lng]); });
      if (pts.length < 2) { map.setView([origin.lat, origin.lng], 13); return; }
      map.fitBounds(L.latLngBounds(pts).pad(0.25), { animate: true });
    }

    function renderList() {
      var items = view.items;
      var ids = {};
      items.forEach(function (l) { ids[l.id] = true; });
      lojas.forEach(function (l) {
        var m = markers[l.id];
        if (ids[l.id]) { if (!map.hasLayer(m)) m.addTo(map); }
        else if (map.hasLayer(m)) { map.removeLayer(m); }
      });

      listEl.innerHTML = "";
      if (items.length === 0) {
        listEl.innerHTML = '<p class="lk-store-empty">' + esc(view.empty) + "</p>";
      } else {
        var iconImg = iconUrl
          ? '<img class="lk-store-card__icon" src="' + esc(iconUrl) + '" alt="" aria-hidden="true">'
          : "";
        items.forEach(function (loja, i) {
          var sel = loja.id === selectedId;
          var btn = document.createElement("button");
          btn.type = "button";
          btn.id = "lk-loja-" + loja.id;
          btn.className = "lk-store-card" + (sel ? " is-active" : "");

          var dist = "";
          if (view.mode === "proximity" && typeof loja._km === "number") {
            dist =
              '<span class="lk-store-card__dist' + (i === 0 ? " is-nearest" : "") + '">' +
              (i === 0 ? "Mais próxima · " : "") + "a " + esc(formatKm(loja._km)) +
              "</span>";
          }

          btn.innerHTML =
            iconImg +
            '<span class="lk-store-card__body">' +
            '<span class="lk-store-card__name">' + esc(loja.nome) + "</span>" +
            '<span class="lk-store-card__city">' + esc(loja.cidade) + " - " + esc(loja.uf) + "</span>" +
            '<span class="lk-store-card__addr">' + esc(loja.endereco) + "</span>" +
            dist +
            "</span>";
          btn.addEventListener("click", function () { select(loja.id); });
          listEl.appendChild(btn);
        });
      }

      var base = items.length + " loja" + (items.length !== 1 ? "s" : "") +
                 " encontrada" + (items.length !== 1 ? "s" : "");
      countEl.textContent = view.note ? base + " · " + view.note : base;
    }

    /* Corrida de respostas: só a busca mais recente pode escrever na tela. */
    var reqSeq = 0;

    function applyQuery() {
      var raw = (searchEl.value || "").trim();
      var q = raw.toLowerCase();
      var seq = ++reqSeq;

      if (!raw) {
        setOriginMarker(null);
        view = { mode: "text", items: lojas, origin: null, note: "", empty: "Nenhuma loja encontrada." };
        renderList();
        map.setView([-15.77972, -47.92972], 4);
        return;
      }

      var cep = asCep(raw);
      if (!cep) {
        setOriginMarker(null);
        var digits = onlyDigits(raw);
        var parcial = /^[\d\s.-]+$/.test(raw) && digits.length > 0 && digits.length < 8;
        view = {
          mode: "text",
          items: textMatch(q),
          origin: null,
          note: "",
          empty: parcial
            ? "Digite os 8 dígitos do CEP para ver as lojas mais próximas."
            : "Nenhuma loja encontrada.",
        };
        renderList();
        return;
      }

      // Modo proximidade
      view = { mode: "text", items: [], origin: null, note: "", empty: "Buscando o CEP…" };
      renderList();

      geocodeCep(cep).then(function (res) {
        if (seq !== reqSeq) return; // chegou tarde, já tem busca mais nova

        var label = cep.slice(0, 5) + "-" + cep.slice(5);

        if (res.status === "ok") {
          var origin = { lat: res.lat, lng: res.lng, label: label };
          var ordenadas = lojas
            .map(function (l) {
              var copy = Object.assign({}, l);
              copy._km = haversineKm(origin, { lat: l.lat, lng: l.lng });
              return copy;
            })
            .sort(function (a, b) { return a._km - b._km; });

          view = {
            mode: "proximity",
            items: ordenadas,
            origin: origin,
            note: "ordenadas por distância de " + label,
            empty: "Nenhuma loja encontrada.",
          };
          setOriginMarker(origin);
          renderList();
          fitToNearest(origin, ordenadas, 3);
          return;
        }

        if (res.status === "nocoords" && res.cidade) {
          // Sem coordenada do CEP: ao menos priorizamos a cidade correta.
          var cidade = res.cidade.toLowerCase();
          var naCidade = lojas.filter(function (l) { return l.cidade.toLowerCase() === cidade; });
          setOriginMarker(null);
          view = {
            mode: "text",
            items: naCidade,
            origin: null,
            note: "sem coordenada para esse CEP — mostrando lojas em " + res.cidade,
            empty: "Nenhuma loja em " + res.cidade + " ainda.",
          };
          renderList();
          if (naCidade.length) {
            fitToNearest({ lat: naCidade[0].lat, lng: naCidade[0].lng }, naCidade, naCidade.length);
          }
          return;
        }

        setOriginMarker(null);
        view = {
          mode: "text",
          items: [],
          origin: null,
          note: "",
          empty: res.status === "notfound"
            ? "CEP não encontrado. Confira os números."
            : "Não consegui consultar o CEP agora. Tente por cidade.",
        };
        renderList();
      });
    }

    function select(id) {
      var prev = selectedId;
      selectedId = id;
      if (prev && markers[prev]) markers[prev].setIcon(markerIcon(false));
      if (markers[id]) markers[id].setIcon(markerIcon(true));
      var loja = lojas.filter(function (l) { return l.id === id; })[0];
      if (loja) {
        map.flyTo([loja.lat, loja.lng], 14, { duration: 0.8 });
        if (markers[id]) markers[id].openPopup();
      }
      renderList();
      var el = document.getElementById("lk-loja-" + id);
      if (el) el.scrollIntoView({ behavior: "smooth", block: "nearest" });
    }

    var debounce;
    searchEl.addEventListener("input", function () {
      clearTimeout(debounce);
      debounce = setTimeout(applyQuery, DEBOUNCE_MS);
    });

    renderList();
    // Leaflet precisa recalcular o tamanho dentro de containers flex
    setTimeout(function () { map.invalidateSize(); }, 250);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
